exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-popup-mask.vux-popup-show {\n  z-index: 5003 !important;\n}\n", ""]);

// exports
